/**
 * Shared DOMPurify configuration for rich post/comment HTML.
 *
 * Used by the `v-sanitized-html` directive (see `plugins/sanitized-html.ts`)
 * and by any component that writes rich HTML to `innerHTML` directly (e.g.
 * `MentionableHtml.vue`). Keeping one source of truth prevents the allowlist
 * from drifting between the two rendering paths.
 */
export const RICH_HTML_SANITIZE_CONFIG = {
  ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'scrolling', 'overlay', 'tooltip'],
  ADD_TAGS: ['iframe'],
  ALLOWED_ATTR: [
    'href',
    'name',
    'target',
    'title',
    'alt',
    'class',
    'id',
    'style',
    'src',
    'width',
    'height',
    'allow',
    'allowfullscreen',
    'scrolling',
    'frameborder',
    'overlay',
    'tooltip',
    'controls',
    'type',
    'data-*',
  ],
  ALLOWED_TAGS: [
    'a',
    'abbr',
    'acronym',
    'address',
    'article',
    'aside',
    'b',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hgroup',
    'hr',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'menu',
    'menuitem',
    'meter',
    'nav',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'u',
    'ul',
    'var',
    'video',
    'audio',
    'wbr',
    'iframe',
  ],
}
